<!----
    Author: hjlee
    Description:
        유료회원 전환 모달
---->
<template>
  <b-modal
    id="modal"
    ref="modalRef"
    :title="$t('common.modal.title.confirm')"
    :ok-title="$t('common.button.ok')"
    :cancel-title="$t('common.button.cancel')"
    :ok-disabled="!order.buyerNm || !order.buyerEmail || !order.buyerTel"
    @ok="confirm"
  >
    <div v-if="!skipPay">
      <div v-html="$t('my_page.notification.convert_to_paid_user')" />
      <br>
      <span class="benefits-guide-button" @click="toggleBenefits($event)">
        {{ $t('common.button.benefits_paid_user') }}
        &nbsp; &nbsp;
        <i v-if="benefitsShown" class="fa fa-chevron-up" />
        <i v-else class="fa fa-chevron-down" />
      </span>
      <div :class="{'benefits-on-modal':true,'benefits-shown': benefitsShown}" v-html="$t('common.notification.paid_user')" />
    </div>
    <div class="settlement-method-area">
      <div class="section-border" />
      <div>
        <div class="settlement-method">
          <input :id="'settlement-method-settlement_method.creditcard'" v-model="order.setleMthCode" type="radio" value="settlement_method.creditcard" name="settlementMethod">
          <label :for="'settlement-method-settlement_method.creditcard'">
            <div class="chk_img" />
            <span class="check-txt">{{ $t('code.nm.settlement_method.creditcard') }}</span>
          </label>
        </div>
      </div>
      <div class="hidden">
        <div class="settlement-method">
          <input :id="'settlement-method-settlement_method.mobile'" v-model="order.setleMthCode" type="radio" value="settlement_method.mobile" name="settlementMethod">
          <label :for="'settlement-method-settlement_method.mobile'">
            <div class="chk_img" />
            <span class="check-txt">{{ $t('code.nm.settlement_method.mobile') }}</span>
          </label>
        </div>
      </div>
      <input-control
        ref="settlementForm.name"
        v-model="order.buyerNm"
        type="text"
        name="buyer_nm"
        :title="$t('column.nm.buyer_nm')"
        :required="true"
      />
      <input-control
        ref="settlementForm.tel"
        v-model="order.buyerTel"
        type="tel"
        name="buyer_tel"
        :title="$t('column.nm.buyer_tel')"
        :required="true"
      />
      <input-control
        ref="settlementForm.email"
        v-model="order.buyerEmail"
        type="email"
        name="buyer_email"
        :title="$t('column.nm.buyer_email')"
        :required="true"
      />
      <div class="section-border" />
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      settlementMethods: [],
      order: {
        setleMthCode: 'settlement_method.creditcard',
        buyerNm: '',
        buyerEmail: '',
        buyerTel: ''
      },
      benefitsShown: false,
      skipPay: false
    }
  },
  mounted() {
    this.loadSettlementMethods()
  },
  methods: {
    toggleBenefits() {
      this.benefitsShown = !this.benefitsShown
      this.$forceUpdate()
    },
    loadSettlementMethods() {
      if (!this.configs) {
        setTimeout(this.loadSettlementMethods, 100)
        return
      }
      if (this.loggedInUser) {
        this.order.buyerNm = this.loggedInUser.nm
        this.order.buyerEmail = this.loggedInUser.email
        this.order.buyerTel = this.loggedInUser.mobile
      }
      this.settlementMethods = []
      for (let i = 0; i < this.configs.settlement_methods.length; i++) {
        this.settlementMethods.push({
          code: this.configs.settlement_methods[i].value,
          nm: this.configs.settlement_methods[i].textCode
        })
      }
    },
    confirm(evt) {
      this.order.skipPay = this.skipPay
      this.$eventHub.$emit('doConvertToPaidUser', this.order)
    }
  }
}
</script>

<style scoped>
.benefits-guide-button {
  margin-left: 0;
  padding: 10px;
  font-size: 1.2rem;
}
.benefits-on-modal {
  max-height: 0;
  overflow: hidden;
  transition: all 0.4s;
  margin-bottom: 30px;
}
.benefits-on-modal.benefits-shown {
  max-height: none;
  margin-top: 20px;
  padding: 10px;
  background-color: #000000;
  color: white;
  border: 1px solid #aaaaaa;
  border-radius: 10px;
}
</style>
